var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlonbar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33241 17.8029H4.49707V16.3769H7.46951C7.94678 16.3769 8.33241 16.7588 8.33241 17.2272V17.8029Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33241 20.6568H4.49707V19.2308H7.46951C7.94678 19.2308 8.33241 19.6127 8.33241 20.0811V20.6568Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9855 20.6568V20.6831C19.9855 21.4714 19.3384 22.1091 18.5385 22.1091H11.2343C10.4344 22.1091 9.78723 21.4714 9.78723 20.6831V14.9377C9.78723 14.1495 9.14005 13.5117 8.34015 13.5117V13.5399L8.33442 13.5117H4.49908V14.9377H8.34206V20.6831C8.34206 22.2577 9.63832 23.5351 11.2362 23.5351H18.5404C20.1383 23.5351 21.4345 22.2577 21.4345 20.6831V20.6568H19.9855Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79089 13.5211V13.4948C9.79089 12.7065 10.4381 12.0688 11.238 12.0688H18.5421C19.342 12.0688 19.9892 12.7065 19.9892 13.4948V19.2402C19.9892 20.0284 20.6364 20.6662 21.4363 20.6662H25.2793V19.2402H21.4363V13.4948C21.4363 11.9201 20.14 10.6428 18.5421 10.6428H11.238C9.64007 10.6428 8.34381 11.9201 8.34381 13.4948V13.5211H9.79089Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1608 27.3278V24.3986C14.1608 23.9283 14.5483 23.5483 15.0237 23.5483H15.6079V27.3278H14.1608Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2647 27.3278V24.3986C11.2647 23.9283 11.6522 23.5483 12.1276 23.5483H12.7118V27.3278H11.2647Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0549 27.3278V24.3986C17.0549 23.9283 17.4425 23.5483 17.9179 23.5483H18.502V27.3278H17.0549Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3323 13.5249H28.1676V14.9509H25.1952C24.7179 14.9509 24.3323 14.569 24.3323 14.1005V13.5249Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3323 10.6729H28.1676V12.0989H25.1952C24.7179 12.0989 24.3323 11.717 24.3323 11.2485V10.6729Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6812 10.6729V10.6465C12.6812 9.85828 13.3284 9.22053 14.1283 9.22053H21.4324C22.2323 9.22053 22.8795 9.85828 22.8795 10.6465V16.3919C22.8795 17.1802 23.5267 17.8179 24.3266 17.8179H28.1696V16.3919H24.3266V10.6465C24.3266 9.07191 23.0303 7.79452 21.4324 7.79452H14.1283C12.5304 7.79452 11.2341 9.07191 11.2341 10.6465V10.6729H12.6812Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5058 4V6.92914C18.5058 7.39946 18.1182 7.77947 17.6429 7.77947H17.0587V4H18.5058Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 4V6.92914C21.4 7.39946 21.0124 7.77947 20.5371 7.77947H19.9529V4H21.4Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6116 4V6.92914C15.6116 7.39946 15.2241 7.77947 14.7487 7.77947H14.1645V4H15.6116Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlonbar);
export default __webpack_public_path__ + "static/media/klonbar.be9852c33986c8a50a5c889db9376645.svg";
export { ForwardRef as ReactComponent };